import React from "react";
import './exam-prep-report-inline.scss';
import { getImageSource } from "../../../../utility/image-source";
import { ImageConstants } from "../../../../constants/constants";
import Loading from "../../../common/loading/loading";
import SessionCache from "../../../routes/session-cache";
import ReactTooltip from 'react-tooltip';
import SchoolApi from '../../../../apis/school';

class ExamPrepReportInline extends React.Component {

    state = {
        isLoading: false,
        data: [],
        notAttemptedUsers: [],
        chapterTitle: '',
        totalStudents: 0,
        totalAttempted: 0,
        avgPercentage: 0,
        totalMark: 0,
        userInfo: {},
        activeTooltip: null
    }

    componentDidMount() {
        let userInfo = SessionCache.getUser();
        this.setState({ userInfo });
        this.fetchReport();
    }

    fetchReport() {
        const { selectedItem } = this.props;
        const payload = {
            board: selectedItem.board,
            class: selectedItem.class,
            section: selectedItem.section,
            assessmentId: typeof selectedItem._id === 'object'
                ? (selectedItem._id.$oid || selectedItem._id.toString())
                : (selectedItem._id || '')
        };

        this.setState({ isLoading: true });

        SchoolApi.getExamPrepReportData(payload)
            .then(res => {
                if (res && res.success) {
                    this.setState({
                        data: res.data || [],
                        notAttemptedUsers: res.notAttemptedUsers || [],
                        chapterTitle: res.chapterTitle || '',
                        totalStudents: res.totalStudents || 0,
                        totalAttempted: res.totalAttempted || 0,
                        avgPercentage: res.avgPercentage || 0,
                        totalMark: res.totalMark || 0,
                        isLoading: false
                    });
                } else {
                    this.setState({ isLoading: false });
                }
            })
            .catch(err => {
                console.error('[ExamPrepReportInline] Error:', err);
                this.setState({ isLoading: false });
            });
    }

    onClickBack() {
        this.props.close && this.props.close();
    }

    getDate(timeStamp) {
        let dateFormat = new Date(timeStamp).toDateString();
        let date = dateFormat.split(" ")[2];
        let month = dateFormat.split(" ")[1];
        let year = dateFormat.split(" ")[3];
        return `${date} ${month} ${year}`;
    }

    onClickDownloadExcel = () => {
        const { selectedItem } = this.props;
        const payload = {
            board: selectedItem.board,
            class: selectedItem.class,
            section: selectedItem.section,
            assessmentId: typeof selectedItem._id === 'object'
                ? (selectedItem._id.$oid || selectedItem._id.toString())
                : (selectedItem._id || ''),
            format: 'excel'
        };
        SchoolApi.getExamPrepReport(payload)
            .then(res => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                const sanitizeFileName = (str) => (str || '').toString().replace(/\s+/g, '').replace(/[^a-zA-Z0-9\-_]/g, '');
                const { chapterTitle } = this.state;
                const fileNameParts = [
                    'ExamPrepReport',
                    sanitizeFileName(this.state.userInfo?.schoolInfo?.schoolCode),
                    sanitizeFileName(selectedItem.class),
                    sanitizeFileName(selectedItem.section),
                    sanitizeFileName(chapterTitle),
                    new Date().toISOString().replace(/:/g, '-')
                ].filter(Boolean);
                a.download = fileNameParts.join('_') + '.xlsx';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            })
            .catch(err => {
                console.error(err);
                alert("Error downloading Excel report.");
            });
    }

    onClickDownloadPdf = () => {
        const { selectedItem } = this.props;
        const payload = {
            board: selectedItem.board,
            class: selectedItem.class,
            section: selectedItem.section,
            assessmentId: typeof selectedItem._id === 'object'
                ? (selectedItem._id.$oid || selectedItem._id.toString())
                : (selectedItem._id || ''),
            format: 'pdf'
        };
        this.setState({ isLoading: true });
        SchoolApi.getExamPrepReport(payload)
            .then(res => {
                this.setState({ isLoading: false });
                if (res && res.success && res.pdfLink) {
                    window.open(res.pdfLink, "_blank");
                } else {
                    alert("Error downloading PDF report.");
                }
            })
            .catch(err => {
                console.error(err);
                this.setState({ isLoading: false });
                alert("Error downloading PDF report.");
            });
    }

    getScoreClass(percentage) {
        if (percentage >= 80) return "score-green";
        if (percentage >= 50) return "score-orange";
        return "score-red";
    }

    getSectionTitle(key) {
        const titles = {
            'revise': 'Chapter Revision',
            'practice': 'Practice',
            'prepareAndCaseStudy': 'Prepare & Case Study',
            'cheatSheet': 'Cheat Sheet',
            'thingsToRemember': 'Things To Remember',
            'commonErrors': 'Common Errors',
            'tipsAndTricks': 'Tips & Tricks'
        };
        return titles[key] || key;
    }

    render() {
        const { selectedItem } = this.props;
        const { data, notAttemptedUsers, chapterTitle, totalStudents, totalAttempted, avgPercentage, isLoading } = this.state;

        return (
            <div>
                <div className="exam-prep-report-inline">
                    {isLoading ? <Loading /> :
                        <>
                            <div>
                                <img alt="" className='back-icon cursor-pointer mb-3' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                            </div>

                            <div className="school-name">Exam Prep Report</div>

                            {/* #5: export row — flex so buttons never overflow */}
                            <div className="epr-header-row mb-3">
                                <div className="header-subtext">{this.state.userInfo?.schoolInfo?.name}</div>
                                <div className="d-flex">
                                    <div className="export-button cursor-pointer mr-2" onClick={this.onClickDownloadPdf}>
                                        Export to PDF
                                    </div>
                                    <div className="export-button cursor-pointer" onClick={this.onClickDownloadExcel}>
                                        Export to Excel
                                    </div>
                                </div>
                            </div>

                            <div className="student-basic-details mt-3">
                                <div className="student-detail-header">Summary</div>

                                {/* #3: 3-column grid: label | colon | value — colons always align */}
                                <div className="summary-row mt-3">
                                    <div className="summary-col">
                                        <div className="summary-grid">
                                            <span className="sg-label">Class</span>
                                            <span className="sg-colon">:</span>
                                            <span className="sg-value">{selectedItem.class ? selectedItem.class.split(' ')[1] : ''}</span>

                                            <span className="sg-label">Section</span>
                                            <span className="sg-colon">:</span>
                                            <span className="sg-value">{selectedItem.section || ''}</span>

                                            <span className="sg-label">Date</span>
                                            <span className="sg-colon">:</span>
                                            <span className="sg-value">{this.getDate(selectedItem.createdDateTimestamp)}</span>

                                            <span className="sg-label">Chapter</span>
                                            <span className="sg-colon">:</span>
                                            <span className="sg-value">{chapterTitle}</span>

                                            {/* <span className="sg-label">Question Set</span>
                                            <span className="sg-colon">:</span>
                                            <span className="sg-value">{selectedItem.selectedQuestionSetTitle || 'W2(Base Line)'}</span> */}
                                        </div>
                                    </div>
                                    <div className="summary-col summary-col--right">
                                        <div className="summary-grid">
                                            <span className="sg-label">Total Eligible Students</span>
                                            <span className="sg-colon">:</span>
                                            <span className="sg-value">{Math.round(totalStudents)}</span>

                                            <span className="sg-label">Total Attempted</span>
                                            <span className="sg-colon">:</span>
                                            <span className="sg-value">{totalAttempted}</span>

                                            {/* <span className="sg-label">Average Completion %</span>
                                            <span className="sg-colon">:</span>
                                            <span className="sg-value">{avgPercentage}%</span> */}
                                        </div>
                                    </div>
                                </div>

                                {/* #7: lighter table header so teal section bars stand out */}
                                <div className="performance-overview mt-4">
                                    <div className="student-detail-header">Student Revision Status</div>
                                    {/* #1 & #4: no overflow:hidden, fixed column sizes via colgroup */}
                                    <div className="competency-table mt-3 table-responsive">
                                        <table className="table table-bordered table-striped mb-0" style={{ tableLayout: 'fixed' }}>
                                            <colgroup>
                                                <col style={{ width: '7%' }} />
                                                <col style={{ width: '30%' }} />
                                                <col style={{ width: '15%' }} />
                                                <col style={{ width: '10%' }} />
                                                <col style={{ width: '18%' }} />
                                                <col style={{ width: '20%' }} />
                                            </colgroup>
                                            <thead className="class-header">
                                                <tr className="first-header-bg">
                                                    <th>S.No</th>
                                                    <th>Name</th>
                                                    <th>Class</th>
                                                    <th>Section</th>
                                                    <th>Baseline Score (%)</th>
                                                    <th>Completion (%)</th>
                                                </tr>
                                            </thead>
                                            <tbody id="exam-prep-rows" className="class-body">
                                                {data && data.length > 0 ? (
                                                    data.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.name}</td>
                                                            <td>{item.className}</td>
                                                            <td>{item.section || ''}</td>
                                                            <td>{item.baselineScore !== undefined ? item.baselineScore : '-'}</td>
                                                            {/* #2: icon sits tight next to value, not floated to edge */}
                                                            <td className={this.getScoreClass(item.percentage)}>
                                                                <div className="completion-cell">
                                                                    <span>{item.percentage}%</span>
                                                                    {item.completedSections && item.completedSections.length > 0 && (
                                                                        /* #1: position:relative wrapper anchors tooltip correctly */
                                                                        <span className="info-anchor">
                                                                            <img
                                                                                className='cursor-pointer'
                                                                                style={{ width: '15px', height: '15px', display: 'block' }}
                                                                                src={getImageSource(ImageConstants.INFO_BLUE)}
                                                                                alt="info"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    const tooltipId = `cs-${index}`;
                                                                                    if (this.state.activeTooltip === tooltipId) {
                                                                                        ReactTooltip.hide();
                                                                                        this.setState({ activeTooltip: null });
                                                                                    } else {
                                                                                        ReactTooltip.hide();
                                                                                        this.setState({ activeTooltip: tooltipId }, () => {
                                                                                            ReactTooltip.show(e.currentTarget);
                                                                                        });
                                                                                    }
                                                                                }}
                                                                                data-tip
                                                                                data-for={`cs-${index}`}
                                                                            />
                                                                            <ReactTooltip
                                                                                id={`cs-${index}`}
                                                                                place="right"
                                                                                effect="solid"
                                                                                globalEventOff="click"
                                                                                clickable={true}
                                                                                className="custom-tooltip-theme"
                                                                                afterHide={() => {
                                                                                    if (this.state.activeTooltip === `cs-${index}`) {
                                                                                        this.setState({ activeTooltip: null });
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <div className="text-left">
                                                                                    <div className="mb-2 pb-1 tooltip-header">Completed Sections</div>
                                                                                    <ul className="pl-3 mb-0" style={{ listStyleType: 'disc' }}>
                                                                                        {item.completedSections.map(sec => (
                                                                                            <li key={sec}>{this.getSectionTitle(sec)}</li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </div>
                                                                            </ReactTooltip>
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center text-muted py-3">
                                                            No Students Found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* #6: flex-wrap grid for not-attempted names */}
                                <div className="not-attempted-label mt-4 mb-2">Not Started Students :</div>
                                {notAttemptedUsers && notAttemptedUsers.length > 0 ? (
                                    <div className="not-attempted-students-list">
                                        {notAttemptedUsers.map((user, index) => (
                                            <span key={index} className="not-attempted-tag">
                                                {user}{index < notAttemptedUsers.length - 1 ? ', ' : ''}
                                            </span>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="light-text mb-4">No Students</div>
                                )}
                            </div>
                        </>
                    }
                </div>
                <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                    multiline={true} place='bottom' type='light' effect='solid'
                    event="mouseover mouseenter"
                    eventOff="mouseleave mouseout scroll mousewheel blur"
                />
            </div>
        );
    }
}

export default ExamPrepReportInline;
